"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const formik_1 = require("formik");
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const RenderRadioField_1 = __importDefault(require("./RenderRadioField"));
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
    },
    option: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        flexGrow: 1,
        position: 'relative',
    },
}));
const RenderRadioGroupField = (props) => {
    const { field: { name, value }, form: { touched, errors, submitCount, setFieldValue }, options, columns, label, labelClass, onChange, } = props;
    const classes = useStyles();
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const onValueChange = (value) => {
        setFieldValue(name, value);
        onChange(value);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { marginY: "5px" },
            react_1.default.createElement(core_1.InputLabel, { className: (0, clsx_1.default)(labelClass) }, label)),
        react_1.default.createElement("div", { className: classes.container }, options.map((option, key) => (react_1.default.createElement("div", { key: key, className: classes.option, style: {
                maxWidth: `${100 / columns}%`,
            } },
            react_1.default.createElement(formik_1.Field, { name: name, text: option.label, component: RenderRadioField_1.default, onValueChange: () => onValueChange(option.value), value: option.value, color: "primary", defaultChecked: String(value) === String(option.value) }))))),
        displayErrors && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error" }, error))));
};
RenderRadioGroupField.defaultProps = {
    columns: 1,
    options: [],
    onChange: () => undefined,
};
RenderRadioGroupField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    options: prop_types_1.default.array.isRequired,
    placeholder: prop_types_1.default.string,
    columns: prop_types_1.default.number,
    textStyle: prop_types_1.default.any,
    label: prop_types_1.default.string,
    labelClass: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
};
exports.default = RenderRadioGroupField;
